import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import HoverCard from "../library/HoverCard";
export const GuestWrapper = styled.section`
  i {
    font-size: 18px !important;
  }
  svg {
    margin-right: 5px;
  }
  margin-bottom: 5px;
`;
export const Wrapper = styled.section`
  display: inline-block;
`;

const ChimneyName = (props) => {
  const { user, showGuestTag, asLink } = props;
  if (!user || Object.keys(user).length === 0) {
    return null;
  }
  const isGuest = user.guest || false;
  const userDir = user.chim_dir || user.chimdir || user.dir || null;
  return (
    <Wrapper>
      {!isGuest && (
        <span className="chim-name">
          {userDir && asLink && (
            <HoverCard chim_dir={userDir} type="profile">
              <Link to={`/profile/${userDir}`}>{user.full_name} Chimney</Link>
            </HoverCard>
          )}
          {userDir && !asLink && <span>{user.full_name} Chimney</span>}
          {/* Used in Comments */}
          {/* {!user.chimdir && <span>{author}</span>} */}
        </span>
      )}

      {isGuest && (
        <GuestWrapper>
          <FontAwesomeIcon icon="user-secret" className="user-secret" />
          <a href={user.guest.url} target="_blank" rel="noopener noreferrer">
            {user.guest.name}
          </a>{" "}
          {showGuestTag && <span>(Guest Chimney)</span>}
        </GuestWrapper>
      )}

      {!userDir && user.full_name && <span>{user.full_name}</span>}

    </Wrapper>
  );
};

ChimneyName.propTypes = {
  user: PropTypes.object.isRequired,
  showGuestTag: PropTypes.bool,
  asLink: PropTypes.bool,
};

ChimneyName.defaultProps = {
  showGuestTag: false,
  asLink: true,
};

export const AuthorName = (props) => {
  if (props.user.user_type === "chim") {
    const chimUser = { ...props.user, chimdir: props.user.dir };
    return <ChimneyName user={chimUser} />;
  }
  if (props.user.user_type === "user") {
    return `${props.user.full_name}`;
  }

  return <span>{props.user.full_name}</span>;
};

export default ChimneyName;
